module.exports = __webpack_public_path__ + "img/logo3.07a52d1e.png";